import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Transform } from 'class-transformer';
import { Type } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __InformantNotificationSettings extends ResponseBody {
  /**
   * @deprecated For backwards-compatibility only. Use messageCreated
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private message_created!: boolean;

  @Expose({groups: ['client']})
  public get messageCreated() {
    return this.message_created
  }

  public set messageCreated(value) {
    this.message_created = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use reportUpdated
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private whisper_updated!: boolean;

  @Expose({groups: ['client']})
  public get reportUpdated() {
    return this.whisper_updated
  }

  public set reportUpdated(value) {
    this.whisper_updated = value
  }
}
export type InformantNotificationSettings = Omit<__InformantNotificationSettings, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'message_created' | 'whisper_updated'>
export const InformantNotificationSettings = __InformantNotificationSettings as any as Constructor<InformantNotificationSettings>
